__turbopack_context__.v({
  "align-center": "section-block-module-scss-module__et6HwW__align-center",
  "align-end": "section-block-module-scss-module__et6HwW__align-end",
  "align-space-between": "section-block-module-scss-module__et6HwW__align-space-between",
  "align-start": "section-block-module-scss-module__et6HwW__align-start",
  "align-stretch": "section-block-module-scss-module__et6HwW__align-stretch",
  "block": "section-block-module-scss-module__et6HwW__block",
  "bottom": "section-block-module-scss-module__et6HwW__bottom",
  "justify-center": "section-block-module-scss-module__et6HwW__justify-center",
  "justify-end": "section-block-module-scss-module__et6HwW__justify-end",
  "justify-space-between": "section-block-module-scss-module__et6HwW__justify-space-between",
  "justify-start": "section-block-module-scss-module__et6HwW__justify-start",
  "justify-stretch": "section-block-module-scss-module__et6HwW__justify-stretch",
  "left": "section-block-module-scss-module__et6HwW__left",
  "right": "section-block-module-scss-module__et6HwW__right",
  "text-align-large-center": "section-block-module-scss-module__et6HwW__text-align-large-center",
  "text-align-large-left": "section-block-module-scss-module__et6HwW__text-align-large-left",
  "text-align-large-right": "section-block-module-scss-module__et6HwW__text-align-large-right",
  "text-align-small-center": "section-block-module-scss-module__et6HwW__text-align-small-center",
  "text-align-small-left": "section-block-module-scss-module__et6HwW__text-align-small-left",
  "text-align-small-right": "section-block-module-scss-module__et6HwW__text-align-small-right",
  "top": "section-block-module-scss-module__et6HwW__top",
});
